import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Decorative } from "@faire/design-tokens";
import { Column } from "@faire/web--source/slate/Layout";
import { getSpacing } from "@faire/web--source/slate/spacing";
import { responsiveMediaQueries } from "@faire/web--source/slate/Theme/responsiveMediaQueries";
import * as React from "react";
import styled, { css } from "styled-components";
import { TestimonialCarousel } from "@faire/retailer/components/TestimonialCarousel";
export var QuoteSection = function(param) {
    var backgroundColor = param.backgroundColor;
    return /*#__PURE__*/ _jsxs(_Fragment, {
        children: [
            /*#__PURE__*/ _jsx(TopPadding, {
                $backgroundColor: backgroundColor
            }),
            /*#__PURE__*/ _jsx(StyledTestimonialCarousel, {
                backgroundColor: backgroundColor,
                name: "faire-direct-sign-up-landing-page-testimonials",
                hideStoryLink: true,
                withRetailerCount: true
            }),
            /*#__PURE__*/ _jsx(BottomPadding, {
                $backgroundColor: backgroundColor
            })
        ]
    });
};
var TopPadding = styled(Column).withConfig({
    componentId: "sc-d2380658-0"
})([
    "height:",
    ";",
    "{height:",
    ";}",
    ""
], getSpacing("3x"), responsiveMediaQueries.mobile, getSpacing("8x"), function(props) {
    return props.$backgroundColor ? css([
        "background-color:",
        ";"
    ], props.$backgroundColor) : css([
        "background-color:",
        ";"
    ], Decorative.tint.neutral);
});
var BottomPadding = styled(Column).withConfig({
    componentId: "sc-d2380658-1"
})([
    "height:112px;",
    ""
], function(props) {
    return props.$backgroundColor ? css([
        "background-color:",
        ";"
    ], props.$backgroundColor) : css([
        "background-color:",
        ";"
    ], Decorative.tint.neutral);
});
var StyledTestimonialCarousel = styled(TestimonialCarousel).withConfig({
    componentId: "sc-d2380658-2"
})([
    "height:400px;"
]);
